import api from '@/services/api'

const getTemplates = async () => {
    try {
        const resp = await api.get('templates', {
            params: {
                with: 'askings',
                filter: 'id;title;askings',
            },
        })

        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export { getTemplates }
